import { faLightbulb, faUserGear } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Container, Navbar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Modal from 'components/desktop/_general/Modal/Modal';
import NavigationLanguageSwitch from 'components/desktop/_general/NavigationLanguage/NavigationLanguageSwitch';
import { useJwt } from 'hooks/useJwt';
import { useUser } from 'hooks/useUser';
import { RootState } from 'reducers/rootReducer';
import { UserCornerInfo } from 'types/User/UserCornerInfo/UserCornerInfo';

import { RenderIf } from '../Conditional/RenderIf';

const MainNavigationTop = (): JSX.Element => {
	const reduxUser: UserCornerInfo = useSelector((state: RootState) => state.user);
	const { t } = useTranslation();
	const { logout } = useJwt();
	const { isSystemDeveloper, loading } = useUser();
	const reduxAllowedUiLanguages: string[] = useSelector(
		(state: RootState) => state.allowedUiLanguages
	);
	const [isGoodToKnowModalOpen, setIsGoodToKnowModalOpen] = useState(false);

	const handleOpenGoodToKnowModal = () => {
		setIsGoodToKnowModalOpen(true);
	};

	const handleCloseGoodToKnowModal = () => {
		setIsGoodToKnowModalOpen(false);
	};
	return (
		<div style={mainStyle}>
			<Navbar collapseOnSelect expand="lg">
				<Container>
					<Navbar.Toggle aria-controls="responsive-navbar-nav" />
					<Navbar.Brand>
						<div style={{ display: 'flex', alignItems: 'center', width: '18vh' }}>
							<img
								src={'/img/logo/logo_sm.png'}
								style={{ height: '2rem', boxShadow: 'none' }}
								className="d-inline-block align-text-middle"
							/>
							<div
								style={{
									marginLeft: '0.5rem',
									color: '#6066C1',
								}}
							>
								AI Reports Generator
							</div>
						</div>
					</Navbar.Brand>
					<button
							className="btn btn-outline-secondary"
							onClick={handleOpenGoodToKnowModal}
						>
							<FontAwesomeIcon icon={faLightbulb} className="me-1" />
							Good to know
						</button>

					<div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
						<span style={{ fontSize: '1.5rem', display: 'flex', gap: '0.5rem' }}>
							{!loading && (
								<div>
									{isSystemDeveloper && (
										<div>
											<FontAwesomeIcon icon={faUserGear}></FontAwesomeIcon>
										</div>
									)}
								</div>
							)}{' '}
							{`${reduxUser.firstName} ${reduxUser.lastName}`}
						</span>
						{!loading && (
							<div>
								{isSystemDeveloper && <div>(Developer features enabled)</div>}
							</div>
						)}
					</div>

					<div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
						
						<RenderIf condition={reduxAllowedUiLanguages.length > 1}>
							<NavigationLanguageSwitch />
						</RenderIf>

						<button
							className="btn btn-outline-danger"
							style={{ width: '18vh' }}
							onClick={logout}
						>
							{t('header:LOGOUT')}
						</button>
					</div>
				</Container>
			</Navbar>
			<Modal
				headerIcon={<FontAwesomeIcon icon={faLightbulb} />}
				headerText="Garret's Foodreport Guideline"
				bodyContent={
					<div>
						<iframe
							src="/docs/Garrets-Foodreport-Guideline-AIR_final.pdf"
							title="Garret's Foodreport Guideline"
							style={{
								width: '100%',
								height: '70vh',
								border: '1px solid #dee2e6',
								borderRadius: '4px',
							}}
						/>
						<div className="mt-2">
							<a
								href="/docs/Garrets-Foodreport-Guideline-AIR_final.pdf"
								target="_blank"
								rel="noreferrer"
							>
								Open guideline in a new tab
							</a>
						</div>
					</div>
				}
				isOpen={isGoodToKnowModalOpen}
				close={handleCloseGoodToKnowModal}
				size="xl"
			/>
		</div>
	);
};

export default MainNavigationTop;

const mainStyle: React.CSSProperties = {
	color: '#6066c1',
	padding: '0.4rem',
	borderBottom: '1px solid #dddfff',
	backgroundImage: 'linear-gradient(180deg, #f4f5ff, white)',
};
